module.exports = __webpack_public_path__ + "img/image_5.60684d05.png";